export default __webpack_public_path__ + "static/media/herobg.4746ab9a.svg";